export const linkTheme = {
  variants: {
    primary: ({ colorScheme = "primary" }) => ({
      color: `${colorScheme}.500`,
      _hover: {
        color: `${colorScheme}.600`,
      },
    }),
  },
  defaultProps: {
    variant: "primary",
  },
};
